import { render, staticRenderFns } from "./classlimit.vue?vue&type=template&id=27ebcd3a&scoped=true"
import script from "./classlimit.vue?vue&type=script&lang=js"
export * from "./classlimit.vue?vue&type=script&lang=js"
import style0 from "./classlimit.vue?vue&type=style&index=0&id=27ebcd3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ebcd3a",
  null
  
)

export default component.exports